import createReducer from './../lib/createReducer';
import * as types from './../actions/types';

export const staff = createReducer(
  {
    list: [],
  },
  {
    [types.GET_STAFF_START](state) {
      const newState = Object.assign({}, state, {
        loading: true,
      });

      return newState;
    },
    [types.GET_STAFF_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        list: action.staff,
        loading: false,
      });
      return newState;
    },
    [types.GET_STAFF_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        error: action.error,
        loading: false,
      });

      return newState;
    },
    [types.SET_STAFF_TYPES](state, action) {
      const newState = Object.assign({}, state, {
        types: action.types,
      });

      return newState;
    },
  },
);

export { staff as default };
